var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('a',{attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer"}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t("label.learn_more")))]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }